const PENALTY_AMOUNT_TYPES = {
  SET_PENALTY_AMOUNT_HISTORY: "SET_PENALTY_AMOUNT_HISTORY",
};

export default PENALTY_AMOUNT_TYPES;
